// Quién firma una anotación, para pintarlo en Anotaciones y en Tareas.
//
// El nombre sale de `user_name` / `user_lastname`, que el backend rellena con
// el usuario que la escribió. Antes se pintaba `creator_name`, que no se guarda
// en ningún sitio, así que solo se veía el rol.
//
// ⚠️ Las notas del agente de IA y del sistema se guardan con el `user_id` DEL
// CLIENTE (el modelo exige un ObjectId). Pintar su nombre las firmaría como si
// las hubiera escrito el cliente: van con su propia etiqueta.
//
// 🔴 El CLIENTE no ve nombres de ClaimUp ni del despacho: lo que escriben le
// llega firmado por «ClaimUp» (Edgar, 05/10/2026). El backend ya le quita el
// nombre (services/annotations/recipients.js, `maskAuthorForViewer`); esto pone
// la etiqueta.
import { ROLE_LABELS } from '@claimup/shared/constants/roles';
import { SIDES, sideOf, canSeeHiddenFromClient } from '@claimup/shared/helpers/annotation-recipients';

const MACHINE_AUTHORS = {
  ai_agent: 'Agente IA',
  system: 'Sistema',
};

const CLAIMUP = 'ClaimUp';

/** ¿Esta nota la firma «ClaimUp» para quien la mira? */
const signsAsClaimUp = (note, viewerRole) => {
  if (canSeeHiddenFromClient(viewerRole)) return false;
  const side = sideOf(note?.creator_role);
  return side === SIDES.CLAIMUP || side === SIDES.PARTNER;
};

export function annotationAuthor(note, viewerRole) {
  if (MACHINE_AUTHORS[note?.creator_role]) return MACHINE_AUTHORS[note.creator_role];
  if (signsAsClaimUp(note, viewerRole)) return CLAIMUP;
  const name = [note?.user_name, note?.user_lastname].filter(Boolean).join(' ').trim();
  return name || ROLE_LABELS[note?.creator_role] || note?.creator_role || '';
}

/** El rol, para el tooltip de la etiqueta. Al cliente no se le dice cuál. */
export function annotationRoleLabel(note, viewerRole) {
  if (MACHINE_AUTHORS[note?.creator_role]) return MACHINE_AUTHORS[note.creator_role];
  if (signsAsClaimUp(note, viewerRole)) return CLAIMUP;
  return ROLE_LABELS[note?.creator_role] || note?.creator_role || '';
}
